import { useEffect, useState, useCallback } from "react";
import useUser from "../user/useUser";
import settlementsService from "../../services/settlementsService";

const useTerminals = () => {
  const { branch: defaultBranch } = useUser();
  const [loading, setLoading] = useState(false);
  const [terminals, setTerminals] = useState([]);

  const SearchTerminals = useCallback(async (branch = defaultBranch) => {
    const pvIds = (branch?.pvs?.length > 0) ? branch.pvs.map((p) => p.id) : []
    
    setLoading(true);
    await settlementsService
      .SearchTerminals({ isExport: true, active: true, pvIds })
      .then((res) => setTerminals(res.values))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    if (defaultBranch?.pvs && defaultBranch.pvs.length) {
      SearchTerminals(defaultBranch);
    }
  }, [defaultBranch, SearchTerminals]);

  return {
    terminals,
    loading,
    SearchTerminals,
  };
}

export default useTerminals;